import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { authSlice } from './auth'
import { companySlice } from './company'
import { editorSlice } from './editor'
import { helperSlice } from './helper'
import { meetingSlice } from './meeting'
import { menuSlice } from './menu'
import { playerSlice } from './player'
import { recordSlice } from './record'
import { transcriptSlice } from './transcript'
import { triggerSlice } from './trigger'
import { uploadSlice } from './upload'

// must stay a factory: the server module registry is shared between requests,
// so a module level store instance would leak state from one user's render into
// the next one - StoreProvider creates a fresh store per render tree instead
export const makeStore = () => configureStore({
  devTools: true,
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [companySlice.name]: companySlice.reducer,
    [triggerSlice.name]: triggerSlice.reducer,
    [uploadSlice.name]: uploadSlice.reducer,
    [menuSlice.name]: menuSlice.reducer,
    [editorSlice.name]: editorSlice.reducer,
    [playerSlice.name]: playerSlice.reducer,
    [recordSlice.name]: recordSlice.reducer,
    [transcriptSlice.name]: transcriptSlice.reducer,
    [meetingSlice.name]: meetingSlice.reducer,
    [helperSlice.name]: helperSlice.reducer,
    //...root,
  },
})

export type AppStore = ReturnType<typeof makeStore>
export type State = ReturnType<AppStore['getState']>

export type AppDispatch = AppStore['dispatch']
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<State> = useSelector
